import { enUS as enUSCore, ptBR as ptBRCore } from '@mui/material/locale';
import { enUS as enUSDataGrid, ptBR as ptBRDataGrid } from '@mui/x-data-grid/locales';
import { enUS as enUSDate, ptBR as ptBRDate } from '@mui/x-date-pickers/locales';
import { enUS as enUSAdapter, ptBR as ptBRAdapter } from 'date-fns/locale';
import merge from 'lodash/merge';

// PLEASE REMOVE `LOCAL STORAGE` WHEN YOU CHANGE SETTINGS.
// ----------------------------------------------------------------------

export const allLangs = [
  {
    label: 'Português',
    value: 'pt-BR',
    systemValue: merge(ptBRDate, ptBRDataGrid, ptBRCore),
    adapterLocale: ptBRAdapter,
    icon: 'flagpack:pt-BR',
  },
  {
    label: 'English',
    value: 'en',
    systemValue: merge(enUSDate, enUSDataGrid, enUSCore),
    adapterLocale: enUSAdapter,
    icon: 'flagpack:gb-nir',
  },
];

export const defaultLang = allLangs[0]; // Português

// GET MORE COUNTRY FLAGS
// https://icon-sets.iconify.design/flagpack/
// https://www.dropbox.com/sh/nec1vwswr9lqbh9/AAB9ufC8iccxvtWi3rzZvndLa?dl=0
